import React from 'react';
export var DeviceContext = /*#__PURE__*/React.createContext();